import { queries } from '#zero/queries.ts'

/** Matches the home page list — keep in sync with `HomeTasksList`. */
export const HOME_TASKS_LIST_LIMIT = 50

export function homeTasksListQuery(workspaceId: string) {
  return queries.implementations.listAll({
    workspaceId,
    filter: 'active',
    limit: HOME_TASKS_LIST_LIMIT,
  })
}
